/**
 * @generated SignedSource<<a9c7e0eb84eee3e3be913cfb181cc09f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserAvatar_member$data = {
  readonly avatar: {
    readonly url: URIString;
  } | null;
  readonly email: string;
  readonly name: string;
  readonly " $fragmentType": "UserAvatar_member";
};
export type UserAvatar_member$key = {
  readonly " $data"?: UserAvatar_member$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_member">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserAvatar_member",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MemberAvatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Member",
  "abstractKey": null
};

(node as any).hash = "fd809fa5ced50c5258878880d85ba55a";

export default node;
